import React from "react";
import { useTranslation } from "react-i18next";
import { faCircleCheck } from "@fortawesome/pro-solid-svg-icons";
import { Button } from "../shared/Button/Button";
import { useDeviceHook } from "../../utils/hooks/useDeviceHook";
import { StyledIcon } from "../MissingBillingInformation/SuccessMessage.styles";
import { getCardIcon } from "../BabyPeek/BabyPeekStripe";
import { GetTypographyContent } from "../shared/Typography/Typography";
import {
  PaymentMethodCard,
  PaymentMethodLabel,
  PaymentMethodInfo,
  CardIconImage,
  CardInfo,
} from "../PaymentMethod/PaymentMethod.styles";
import { Title, Subtitle } from "../shared/Modal/Modal.styles";
import { themePalette } from "../../theme";
import {
  SuccessContainer,
  IconContainer,
  ButtonContainer,
} from "./EditPaymentMethodModal.styles";

interface EditPaymentMethodSuccessMessageProps {
  onPrimaryAction: () => void;
  updatedPaymentMethod: {
    card_brand: string;
    last_four_digits: string;
  };
}

export const EditPaymentMethodSuccessMessage: React.FC<
  EditPaymentMethodSuccessMessageProps
> = ({ onPrimaryAction, updatedPaymentMethod }) => {
  const { deviceType } = useDeviceHook();
  const { t } = useTranslation();

  return (
    <SuccessContainer>
      <IconContainer>
        <StyledIcon
          icon={faCircleCheck}
          $iconColor={themePalette.greenSuccess}
        />
      </IconContainer>

      <Title>{t("upfrontPayment.editPaymentMethod.successTitle")}</Title>
      <Subtitle>
        {t("upfrontPayment.editPaymentMethod.successSubtitle")}
      </Subtitle>

      <PaymentMethodCard>
        <PaymentMethodLabel>
          {t("upfrontPayment.editPaymentMethod.paymentMethod")}
        </PaymentMethodLabel>
        <PaymentMethodInfo>
          <CardInfo>
            <CardIconImage
              src={getCardIcon(updatedPaymentMethod.card_brand)}
              alt={`${updatedPaymentMethod.card_brand} card`}
            />
            {GetTypographyContent({
              content: `${updatedPaymentMethod.card_brand.toUpperCase()} •••• ${updatedPaymentMethod.last_four_digits}`,
              size: "medium",
              textColor: "black",
            })}
          </CardInfo>
        </PaymentMethodInfo>
      </PaymentMethodCard>

      <ButtonContainer>
        <Button
          label={t("upfrontPayment.actions.ok")}
          data-testid="primary-action-button"
          onClick={onPrimaryAction}
          fullWidth
          size="medium"
          backgroundColor="greenDark"
        />
      </ButtonContainer>
    </SuccessContainer>
  );
};
